import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import {Offer} from '@/models/simulation/Simulation';
import {ScheduleRow} from '@/components/calculator/schedule/Schedule';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterestRateRow',
  props: {
    offer: null,
    row: null,
    colspan: { default: 1 },
    print: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { offer: Offer, row: ScheduleRow, colspan: number, print: boolean }



const scheduleStore = useScheduleStore();

const interestRateLabel = computed(() => props.offer.features.variableInterest || props.row.currentMonth > 1
  ? I18NGetter().useScheduleTable.VARIABLE_INTEREST_RATE
  : I18NGetter().useScheduleTable.FIXED_INTEREST_RATE
);

const chosenInstallmentType = computed(() => scheduleStore.userInput?.fixedInstallments
  ? I18NGetter().useScheduleTable.FIXED_INSTALLMENTS
  : I18NGetter().useScheduleTable.DESCENDING_INSTALLMENTS
);

const homeStartProgramLabel = computed(() => {
  if (!scheduleStore.isHomeStartProgram) return ''
  return props.row.currentMonth > 1
    ? chosenInstallmentType.value
    : 'okres dopłat'
});


return { __sfc: true,props, scheduleStore, interestRateLabel, chosenInstallmentType, homeStartProgramLabel }
}

})